/* Suprimal cart: drawer + cart page on Shopify's AJAX Cart API and Section Rendering. Changes show at once; Shopify catches up behind. */
(function () {
  'use strict';
  var d = document, html = d.documentElement;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var opener = null, tBag = null, inflight = 0;

  function bag() { return d.querySelector('[data-sp-bag]'); }
  function roots() { return [].slice.call(d.querySelectorAll('[data-sp-cart][data-section]')); }
  function onPage() { return !!d.querySelector('[data-sp-cart][data-mode="page"]'); }
  function ids() {
    var seen = {};
    return roots().map(function (r) { return r.getAttribute('data-section'); }).filter(function (x) { if (!x || seen[x]) return false; seen[x] = 1; return true; }).join(',');
  }
  function money(c) {
    if (window.Suprimal && window.Suprimal.money) return window.Suprimal.money(c);
    return (c / 100).toFixed(2);
  }
  function esc(s) { return String(s || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function uniq(a) { var o = {}; return a.filter(function (x) { x = x.trim(); if (!x || o[x.toUpperCase()]) return false; o[x.toUpperCase()] = 1; return true; }); }

  function busy(on) {
    inflight = Math.max(0, inflight + (on ? 1 : -1));
    roots().forEach(function (r) { r.classList.toggle('is-busy', inflight > 0); });
  }
  function announce(msg) { var l = d.querySelector('[data-sp-cart-live]'); if (l) { l.textContent = ''; setTimeout(function () { l.textContent = msg; }, 60); } }
  function post(url, body) {
    /* requests go out as a Request object: the subscription app's fetch override only rewrites fetch(url, { method: 'POST' }) calls, and would otherwise swap the plan the shopper picked for its own default */
    return fetch(new Request(ROOT + url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Sp-Cart': '1' }, body: JSON.stringify(body) }))
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          if (!r.ok) { var e = new Error(j.description || j.message || 'Something went wrong. Please try again.'); e.data = j; throw e; }
          return j;
        });
      });
  }
  function withSections(body) { body.sections = ids(); body.sections_url = location.pathname; return body; }

  /* ---------- rendering ---------- */
  function count(n) {
    [].slice.call(d.querySelectorAll('.sp-cart-count')).forEach(function (c) {
      var old = c.getAttribute('data-count');
      c.setAttribute('data-count', n); c.textContent = n > 0 ? n : '';
      if (String(old) !== String(n)) { c.classList.remove('is-bump'); c.getBoundingClientRect(); c.classList.add('is-bump'); }
    });
  }
  function focusMark() {
    var a = d.activeElement; if (!a || !a.closest) return null;
    var line = a.closest('.sp-line'); if (!line) return null;
    return { key: line.getAttribute('data-key'), step: a.getAttribute('data-sp-qty-step'), input: a.hasAttribute('data-sp-qty-input'), plan: a.hasAttribute('data-sp-plan-select') };
  }
  function focusRestore(el, m) {
    if (!m) return;
    var line = [].slice.call(el.querySelectorAll('.sp-line')).filter(function (l) { return l.getAttribute('data-key') === m.key; })[0];
    if (!line) return;
    var t = m.step ? line.querySelector('[data-sp-qty-step="' + m.step + '"]') : m.input ? line.querySelector('[data-sp-qty-input]') : m.plan ? line.querySelector('[data-sp-plan-select]') : null;
    if (t) t.focus({ preventScroll: true });
  }
  function render(sections, opts) {
    if (!sections) return;
    var mark = focusMark();
    gsrv = null; sitems = null;
    if (sy.ext) { sy.ext = false; clearTimeout(sy.extT); busy(false); }
    roots().forEach(function (el) {
      var id = el.getAttribute('data-section'), src = sections[id];
      if (!src) return;
      var fresh = new DOMParser().parseFromString(src, 'text/html').querySelector('[data-sp-cart][data-section="' + id + '"]');
      if (!fresh) return;
      var ship = el.querySelector('[data-ship]'), prev = ship ? ship.style.getPropertyValue('--p') : null;
      /* the bag scrolls as one on phones and per column on wide screens: keep every scroll position */
      var tops = [].slice.call(el.querySelectorAll('[data-sp-scroll]')).map(function (x) { return x.scrollTop; });
      el.innerHTML = fresh.innerHTML;
      el.setAttribute('data-count', fresh.getAttribute('data-count') || '0');
      var scl = [].slice.call(el.querySelectorAll('[data-sp-scroll]'));
      scl.forEach(function (x, i) { if (tops[i]) x.scrollTop = tops[i]; });
      hydrate(el, prev);
      focusRestore(el, mark);
      if (opts && opts.newKey) {
        [].slice.call(el.querySelectorAll('.sp-line')).forEach(function (l) {
          if (l.getAttribute('data-key') === opts.newKey) {
            l.classList.add('is-new');
            /* bring the new line into view only if it is out of sight, so the gift and shipping progress above stay on screen */
            var box = scl.filter(function (x) { return x.contains(l) && x.scrollHeight > x.clientHeight + 1; }).pop();
            var lr = l.getBoundingClientRect(), br = box && box.getBoundingClientRect();
            if (box && (lr.top < br.top || lr.bottom > br.bottom)) box.scrollTop = Math.max(0, box.scrollTop + lr.top - br.top - 120);
          }
        });
      }
    });
    var r = roots()[0]; if (r) count(+r.getAttribute('data-count') || 0);
    announce('Bag updated');
  }
  function hydrate(el, prev) {
    var ship = el.querySelector('[data-ship]');
    if (ship) {
      var cents = +ship.getAttribute('data-ship-cents') || 0, base = +ship.getAttribute('data-ship-base') || 0, total = +ship.getAttribute('data-total') || 0;
      if (!cents && base) {
        var rate = parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1;
        cents = Math.round(base * rate);
        var done = total >= cents, msg = ship.querySelector('[data-ship-msg]');
        ship.classList.toggle('is-done', done);
        if (msg) msg.innerHTML = done ? '<span>' + esc(ship.getAttribute('data-done')) + '</span>' : '<span>' + esc(ship.getAttribute('data-left')).replace('[amount]', '<b>' + esc(money(cents - total)) + '</b>') + '</span>';
        ship.style.setProperty('--p', Math.min(100, Math.floor(total * 100 / cents)) + '%');
        ship.hidden = false;
      }
      var target = ship.style.getPropertyValue('--p');
      if (prev && prev !== target) {
        ship.style.setProperty('--p', prev); ship.getBoundingClientRect();
        requestAnimationFrame(function () { requestAnimationFrame(function () { ship.style.setProperty('--p', target); }); });
      }
    }
    mergeSplit(el);
    mbar(el);
    clearTimeout(prT); prT = setTimeout(function () { if (pending()) return; lock(prEnforce).then(function () { return lock(gzEnforce); }); }, 0);
  }
  /* Shopify splits one bag line in two when a discount covers only part of it (the Bottle gift does this): the shopper sees it as the
     one line they added, with the total quantity and price. The parts are kept for the requests that change it. */
  function mergeSplit(el) {
    var seen = {};
    productLines(el).forEach(function (l) {
      var sel = l.querySelector('[data-sp-plan-select]'), ds = sel ? [].filter.call(sel.options, function (o) { return o.defaultSelected; })[0] : null;
      var k = vOf(l.getAttribute('data-key')) + '/' + (ds ? ds.value : ''), q = +l.getAttribute('data-qty') || 0;
      l.__pieces = [{ key: l.getAttribute('data-key'), qty: q }];
      var f = seen[k]; if (!f) { seen[k] = l; return; }
      var n = (+f.getAttribute('data-qty') || 0) + q, fb = f.querySelector('.sp-line__price'), lb = l.querySelector('.sp-line__price');
      var fs = fb && fb.querySelector('strong'), ls = lb && lb.querySelector('strong'), fc = fb && fb.querySelector('s'), lc = lb && lb.querySelector('s');
      if (!fs || !ls) return;
      var fin = (cents(fs.textContent) || 0) + (cents(ls.textContent) || 0), cmp = (cents((fc || fs).textContent) || 0) + (cents((lc || ls).textContent) || 0);
      fs.textContent = money(fin);
      if (fc) fc.textContent = money(cmp);
      else if (cmp > fin) { fc = d.createElement('s'); fc.textContent = money(cmp); fb.insertBefore(fc, fs); }
      f.__pieces = f.__pieces.concat(l.__pieces);
      f.setAttribute('data-qty', n); f.setAttribute('data-unit', Math.round(fin / n));
      if (cmp > fin) f.setAttribute('data-ucmp', Math.round(cmp / n));
      var inp = f.querySelector('[data-sp-qty-input]'); if (inp) { inp.value = n; inp.defaultValue = String(n); }
      l.remove();
    });
  }
  function mbar(el) {
    var bar = el.querySelector('[data-sp-mbar]'), btn = el.querySelector('[data-sp-checkout]');
    if (el.__io) { el.__io.disconnect(); el.__io = null; }
    if (!bar || !btn || !('IntersectionObserver' in window)) return;
    el.__io = new IntersectionObserver(function (en) { en.forEach(function (x) { bar.hidden = x.isIntersecting; }); });
    el.__io.observe(btn);
  }
  function refresh(open) {
    var q = ids();
    if (!q) { if (open) location.href = ROOT + 'cart'; return Promise.resolve(); }
    busy(true);
    /* no Accept: application/json here: on /products/ URLs Shopify would answer with the product JSON instead of the sections */
    return fetch(location.pathname + '?sections=' + encodeURIComponent(q), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (s) { render(s); if (open) openBag(); })
      .catch(function () { if (open) openBag(); })
      .then(function () { busy(false); });
  }

  /* ---------- drawer ---------- */
  function openBag() {
    var b = bag();
    if (!b) { location.href = ROOT + 'cart'; return; }
    if (onPage()) return;
    clearTimeout(tBag);
    if (!opener) opener = d.activeElement;
    var wasOpen = b.classList.contains('is-open');
    b.hidden = false; html.classList.add('sp-bag-open');
    if (!wasOpen) { b.classList.add('is-entering'); clearTimeout(b.__te); b.__te = setTimeout(function () { b.classList.remove('is-entering'); }, 1300); }
    b.getBoundingClientRect(); b.classList.add('is-open');
    if (!wasOpen) setTimeout(function () { var x = b.querySelector('.sp-cart__x') || b.querySelector('.sp-bag__panel'); if (x) x.focus({ preventScroll: true }); }, 80);
  }
  function closeBag() {
    var b = bag(); if (!b || b.hidden) return;
    b.classList.remove('is-open'); html.classList.remove('sp-bag-open');
    tBag = setTimeout(function () { b.hidden = true; }, 560);
    if (opener && opener.focus && d.contains(opener)) opener.focus({ preventScroll: true });
    opener = null;
  }

  /* ---------- cart actions ---------- */
  /* while Shopify catches up, dim only what the bag can't work out by itself: the gift and Protocol boxes, shipping and the plan terms */
  function stale() { roots().forEach(function (r) { var c = r.querySelector('.sp-cart'); if (c) c.classList.add('is-stale'); }); }
  function sectionsJson() {
    return fetch(location.pathname + '?sections=' + encodeURIComponent(ids()), { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (s) { return { sections: s }; });
  }
  function fold(el) {
    el.style.height = el.offsetHeight + 'px'; el.getBoundingClientRect();
    el.classList.add('is-removing'); el.style.height = '0px';
  }
  function unfold(el) { el.classList.remove('is-removing'); el.style.height = ''; }

  /* ---------- the instant bag ---------- */
  /* Every change shows at once: quantity, plan, line price, the free gifts it unlocks or loses and the order summary, worked out with
     the bag's own numbers. Shopify hears about it behind the scenes, one request after another (a cart takes one change at a time);
     changes made in quick succession travel together, and the bag redraws once at the end with Shopify's own numbers. */
  /* what dims while Shopify catches up: only what the bag can't work out itself (the gift and Protocol boxes, shipping, plan terms) */
  (function () {
    if (d.getElementById('sp-instant-css')) return;
    var st = d.createElement('style'); st.id = 'sp-instant-css';
    st.textContent = 'html .sp-cart.is-stale .sp-sum dd,html .sp-cart.is-stale .sp-sum__save,html .sp-cart.is-stale .sp-btn__meta,html .sp-cart.is-stale .sp-cart__mbar-total strong{opacity:1}' +
      'html .sp-cart.is-stale .sp-sum dd[data-sp-wait],html .sp-cart.is-stale .sp-wg,html .sp-cart.is-stale .sp-gl,html .sp-cart.is-stale .sp-pr,html .sp-cart.is-stale .sp-sum__pr,html .sp-cart.is-stale .sp-ship__msg,' +
      'html .sp-cart.is-stale.sp-sum-bad .sp-sum dd,html .sp-cart.is-stale.sp-sum-bad .sp-sum__save,html .sp-cart.is-stale.sp-sum-bad .sp-btn__meta,html .sp-cart.is-stale.sp-sum-bad .sp-cart__mbar-total strong{opacity:.5;transition:opacity .2s}' +
      '.sp-line__terms[hidden]{display:none}' +
      '.sp-line.is-ph-add .sp-line__media:empty{background:color-mix(in srgb,var(--ink) 7%,transparent);border-radius:16px;animation:sp-ph 1.1s ease-in-out infinite}' +
      '.sp-line.is-ph-add .sp-line__meta{color:var(--ink-muted)}@keyframes sp-ph{50%{opacity:.5}}' +
      '@media (prefers-reduced-motion:reduce){.sp-line.is-ph-add .sp-line__media:empty{animation:none}}';
    (d.head || html).appendChild(st);
  })();
  var mx = Promise.resolve();
  function lock(fn) { var p = mx.then(function () { return fn(); }); mx = p.then(null, function () {}); return p; }
  var sy = { t: null, gen: 0, run: false, broken: false, ext: false, extT: null };
  var gsrv = null;
  function pending() { return !!sy.t || sy.run; }
  /* send what is waiting now (before an add, a code or checkout) */
  function flush() {
    if (sy.t) { clearTimeout(sy.t); sy.t = null; return lock(runSync); }
    return mx;
  }
  function schedule(ms) {
    sy.gen++; stale();
    clearTimeout(sy.t);
    sy.t = setTimeout(function () { sy.t = null; lock(runSync); }, ms);
  }
  function cents(txt) { var s = String(txt || '').replace(/[^\d]/g, ''); return s ? +s : null; }
  function productLines(r) { return r ? [].slice.call(r.querySelectorAll('.sp-cart__lines > .sp-line:not(.sp-line--gift)')).filter(function (l) { return l.querySelector('[data-sp-qty-input]'); }) : []; }
  /* a line as Shopify last drew it, as Shopify has it now, and as the shopper wants it */
  function lineRen(l) {
    if (!l.__r) {
      var pr = l.querySelector('.sp-line__price'), hint = l.querySelector('.sp-line__hint'), sel = l.querySelector('[data-sp-plan-select]');
      var ds = sel ? [].filter.call(sel.options, function (o) { return o.defaultSelected; })[0] : null;
      if (hint && !icons[/\d+%/.test(hint.textContent) ? 'sparkle' : 'gift']) { var hs = hint.querySelector('svg'); if (hs) icons[/\d+%/.test(hint.textContent) ? 'sparkle' : 'gift'] = hs.outerHTML; }
      var x = l.__r = {
        qty: +l.getAttribute('data-qty') || 0, plan: ds ? ds.value : '', unit: +l.getAttribute('data-unit') || 0,
        ucmp: l.getAttribute('data-ucmp') ? +l.getAttribute('data-ucmp') : 0, gm: +l.getAttribute('data-gm') || 0, gu: +l.getAttribute('data-gu') || 0, ga: +l.getAttribute('data-ga') || 0,
        price: pr ? pr.innerHTML : '', hint: hint ? hint.cloneNode(true) : null
      };
      /* the price as drawn, to the cent, and the quantity the plan options were priced for (the first part of a split line) */
      var st = pr && pr.querySelector('strong'), sc = pr && pr.querySelector('s');
      x.f0 = st && cents(st.textContent) !== null ? cents(st.textContent) : x.unit * x.qty;
      x.c0 = sc && cents(sc.textContent) !== null ? cents(sc.textContent) : (x.ucmp > x.unit ? x.ucmp * x.qty : x.f0);
      x.cq = (l.__pieces && l.__pieces[0].qty) || x.qty || 1;
    }
    return l.__r;
  }
  function lineWant(l) { if (!l.__w) { var r = lineRen(l); l.__w = { qty: r.qty, plan: r.plan }; } return l.__w; }
  function optionFor(l, plan) {
    var sel = l.querySelector('[data-sp-plan-select]'); if (!sel) return null;
    return [].filter.call(sel.options, function (o) { return o.value === (plan || ''); })[0] || null;
  }
  /* the line's price as the shopper wants it: per tin for the plan, times the quantity, and its compare-at price */
  function lineCalc(l) {
    var r = lineRen(l), w = lineWant(l), unit = r.unit, uc = r.ucmp, pct = null;
    if (w.plan !== r.plan) {
      var o = optionFor(l, w.plan);
      if (o && o.getAttribute('data-up') !== null && o.getAttribute('data-up') !== '') { unit = +o.getAttribute('data-up'); var oc = cents(o.getAttribute('data-compare')); uc = oc ? Math.round(oc / r.cq) : 0; pct = +o.getAttribute('data-pct') || 0; }
    }
    if (w.qty === r.qty && w.plan === r.plan) return { final: r.f0, cmp: r.c0, final0: r.f0, cmp0: r.c0, pct: pct };
    var f = unit * w.qty;
    return { final: f, cmp: uc > unit ? uc * w.qty : f, final0: r.f0, cmp0: r.c0, pct: pct };
  }
  var icons = {};
  function icon(r, name) { return icons[name] || ''; }
  function lineView(l) {
    var r = lineRen(l), w = lineWant(l), box = l.querySelector('.sp-line__price'), root = l.closest('[data-sp-cart]');
    l.classList.toggle('is-sub', !!w.plan);
    if (box) {
      if (w.qty === r.qty && w.plan === r.plan) box.innerHTML = r.price;
      else if (w.qty > 0) {
        var a = lineCalc(l), pct = a.pct;
        if (pct === null) { var sv = box.querySelector('.sp-line__save'); pct = sv ? parseInt(sv.textContent.replace(/\D+/g, ''), 10) || 0 : 0; }
        box.innerHTML = (a.cmp > a.final ? '<s>' + esc(money(a.cmp)) + '</s>' : '') + '<strong>' + esc(money(a.final)) + '</strong>' + (pct > 0 ? '<span class="sp-line__save">Save ' + pct + '%</span>' : '');
      }
    }
    /* the line under the plan: what the plan brings (said at once), its billing terms (back when Shopify answers) */
    var pb = l.querySelector('.sp-line__plan'); if (!pb) return;
    var terms = pb.querySelector('.sp-line__terms'); if (terms) terms.hidden = w.plan !== r.plan;
    var cur = pb.querySelector('.sp-line__hint');
    if (w.plan === r.plan) {
      if (cur && cur !== r.hint) cur.remove();
      if (r.hint && !r.hint.parentNode) pb.insertBefore(r.hint, terms || null);
      return;
    }
    var o = optionFor(l, w.plan), dl = o ? +o.getAttribute('data-deliv') || 1 : 1, sel = pb.querySelector('[data-sp-plan-select]'), max = 0, txt = '', ic = '';
    if (sel) [].forEach.call(sel.options, function (x) { max = Math.max(max, +x.getAttribute('data-pct') || 0); });
    if (w.plan) { if (dl >= 2) { txt = 'Free shipping + ' + (dl >= 3 ? 3 : 2) + ' free Protocols included'; ic = 'gift'; } }
    else if (max > 0) { txt = 'Subscribe: up to ' + max + '% off, free shipping + free Protocols'; ic = 'sparkle'; }
    if (cur) cur.remove();
    if (txt) { var p = d.createElement('p'); p.className = 'sp-line__hint'; p.innerHTML = icon(root, ic) + esc(txt); pb.insertBefore(p, terms || null); }
  }
  /* the order summary as the shopper wants it: subtotal and savings move with each line and gift; percentage discounts scale with the
     subtotal (Shopify's own rounding can differ by a cent, the redraw settles it). Read once from the numbers Shopify drew. */
  function sumBase(r) {
    var dl = r.querySelector('.sp-sum'); if (!dl) return null;
    if (dl.__b) return dl.__b;
    var rows = [].slice.call(dl.querySelectorAll('.sp-sum__row')), b = { discs: [], bad: false };
    b.sub = rows[0] ? rows[0].querySelector('dd') : null;
    b.tot = dl.querySelector('.sp-sum__row--total dd');
    rows.forEach(function (x, i) {
      var dd = x.querySelector('dd'), c = dd ? cents(dd.textContent) : null, dt = x.querySelector('dt'), lbl = dt ? dt.textContent.trim().toLowerCase() : '';
      if (!dd || i === 0 || x.classList.contains('sp-sum__row--total')) return;
      if (x.classList.contains('is-disc') && c > 0) b.discs.push({ dd: dd, c: c });
      else if (x.classList.contains('is-disc') || lbl.indexOf('shipping') === 0) dd.setAttribute('data-sp-wait', '');
    });
    b.sub0 = b.sub ? cents(b.sub.textContent) : null; b.tot0 = b.tot ? cents(b.tot.textContent) : null;
    if (b.sub0 === null || b.tot0 === null) b.bad = true;
    b.items0 = (b.tot0 || 0) + b.discs.reduce(function (s, x) { return s + x.c; }, 0);
    var sv = r.querySelector('.sp-sum__save'); b.save0 = sv ? cents(sv.textContent) : null;
    dl.__b = b; return b;
  }
  function setNum(el, val, prefix) {
    if (!el) return;
    var tn = [].filter.call(el.childNodes, function (n) { return n.nodeType === 3 && /\d/.test(n.nodeValue); }).pop();
    if (tn) tn.nodeValue = tn.nodeValue.replace(/\S*\d[\s\S]*$/, (prefix || '') + money(val));
    else el.textContent = (prefix || '') + money(val);
  }
  function sumView() {
    roots().forEach(function (r) {
      var b = sumBase(r), sc = r.querySelector('.sp-cart'); if (sc) sc.classList.toggle('sp-sum-bad', !b || b.bad);
      if (!b || b.bad) return;
      var dItems = 0, dSave = 0, sureSave = b.save0 !== null;
      productLines(r).forEach(function (l) { var a = lineCalc(l); dItems += a.final - a.final0; dSave += (a.cmp - a.final) - (a.cmp0 - a.final0); });
      ['pouch', 'bottle'].forEach(function (id) {
        var st = r.querySelector('[data-sp-gift-state][data-gift="' + id + '"]'); if (!st) return;
        var c = cents(st.getAttribute('data-cmp')) || 0, real = r.querySelector('.sp-line--gift[data-gift="' + id + '"]:not(.is-ph)');
        var was = !!real, now = !!(real && !real.classList.contains('is-removing')) || !!r.querySelector('.sp-line--gift.is-ph[data-gift="' + id + '"]');
        if (was !== now) dSave += now ? c : -c;
      });
      var items1 = b.items0 + dItems, dDisc = 0;
      b.discs.forEach(function (x) { var c1 = b.items0 > 0 ? Math.round(x.c * items1 / b.items0) : x.c; dDisc += c1 - x.c; x.dd.textContent = '−' + money(c1); });
      b.sub.textContent = money(b.sub0 + dItems);
      var t1 = b.tot0 + dItems - dDisc;
      b.tot.textContent = money(t1);
      [].forEach.call(r.querySelectorAll('.sp-cart__checkout .sp-btn__meta, .sp-cart__mbar-total strong'), function (x) { x.textContent = money(t1); });
      if (sureSave) {
        var s1 = Math.max(0, b.save0 + dSave + dDisc), svl = r.querySelector('.sp-sum__save');
        setNum(svl, s1); if (svl) svl.style.display = s1 > 0 ? '' : 'none';
        var sm = r.querySelector('.sp-cart__mbar-total small'); if (sm && /save/i.test(sm.textContent)) { setNum(sm, s1); sm.style.display = s1 > 0 ? '' : 'none'; }
      }
    });
    /* the counts move with the quantities and gifts: the bag's own (products) and the one in the header (everything) */
    var r0 = roots()[0];
    if (r0) {
      var dq = 0, cc = r0.querySelector('.sp-cart__count');
      productLines(r0).forEach(function (l) { dq += lineWant(l).qty - lineRen(l).qty; });
      if (cc) { if (cc.__n0 == null) cc.__n0 = parseInt(cc.textContent, 10) || 0; cc.textContent = Math.max(0, cc.__n0 + dq); }
      dq += r0.querySelectorAll('.sp-line--gift.is-ph').length - r0.querySelectorAll('.sp-line--gift.is-removing:not(.is-ph)').length;
      count(Math.max(0, (+r0.getAttribute('data-count') || 0) + dq));
    }
  }
  /* a change from the shopper: show it everywhere at once, then tell Shopify */
  function setWant(l, patch, ms) {
    var w = lineWant(l);
    if ('qty' in patch) w.qty = Math.max(0, patch.qty);
    if ('plan' in patch) w.plan = patch.plan || '';
    var inp = l.querySelector('[data-sp-qty-input]'); if (inp && String(inp.value) !== String(w.qty)) inp.value = w.qty;
    var e = l.querySelector('[data-sp-line-err]'); if (e) e.hidden = true;
    if (w.qty <= 0) { if (!l.classList.contains('is-removing')) fold(l); }
    else if (l.classList.contains('is-removing')) unfold(l);
    lineView(l);
    var g = predictGifts(); if (g) giftView(g);
    sumView();
    schedule(ms == null ? 300 : ms);
  }
  function giftSrv(r) {
    if (!gsrv) {
      gsrv = {};
      [].forEach.call(r.querySelectorAll('[data-sp-gift-state]'), function (st) { gsrv[st.getAttribute('data-gift')] = st.getAttribute('data-mine') === '1' ? st.getAttribute('data-key') || '' : ''; });
    }
    return gsrv;
  }
  /* Shopify's product lines as last heard (key, variant, plan, quantity): read from the bag as drawn, then from each answer */
  var sitems = null;
  function vOf(key) { return String(key || '').split(':')[0]; }
  function srvItems(r) {
    if (!sitems) {
      sitems = [];
      productLines(r).forEach(function (l) {
        var x = lineRen(l);
        (l.__pieces || [{ key: l.getAttribute('data-key'), qty: x.qty }]).forEach(function (pc) { sitems.push({ key: pc.key, v: vOf(pc.key), p: x.plan, qty: pc.qty }); });
      });
    }
    return sitems;
  }
  function itemsFrom(cj, vs) {
    return (cj.items || []).filter(function (it) { return !(it.properties && it.properties._gift) && vs[String(it.variant_id)]; }).map(function (it) {
      return { key: it.key, v: String(it.variant_id), p: it.selling_plan_allocation ? String(it.selling_plan_allocation.selling_plan.id) : '', qty: it.quantity };
    });
  }
  /* what the shopper wants, per product and plan */
  function wantTotals(r) {
    var T = {};
    productLines(r).forEach(function (l) { var w = lineWant(l); if (w.qty > 0) { var k = vOf(l.getAttribute('data-key')) + '/' + w.plan; T[k] = (T[k] || 0) + w.qty; } });
    return T;
  }
  function groupsOf(items) {
    var G = {};
    items.forEach(function (it) { var k = it.v + '/' + it.p; if (!G[k]) G[k] = { v: it.v, p: it.p, qty: 0, items: [] }; G[k].qty += it.qty; G[k].items.push(it); });
    return G;
  }
  function biggest(g) { return g.items.reduce(function (a, b) { return b.qty > a.qty ? b : a; }); }
  /* The next request that brings Shopify's product lines to what the shopper wants. A line Shopify split in two acts as one line:
     a plan change moves all of it, and a new quantity on either part moves the total by the difference. */
  function nextStep(items, T) {
    var G = groupsOf(items), keys = Object.keys(G), tk = Object.keys(T), i, j, g, b, n, ng, t;
    for (i = 0; i < keys.length; i++) {
      g = G[keys[i]]; if (T[keys[i]]) continue;
      for (j = 0; j < tk.length; j++) {
        n = tk[j]; ng = G[n];
        if (n.slice(0, n.indexOf('/')) !== g.v) continue;
        var short = T[n] - (ng ? ng.qty : 0); if (short <= 0) continue;
        b = biggest(g);
        /* a plan nobody wants any more becomes the plan the shopper picked, with the right quantity in one go */
        if (b.qty + short - g.qty >= 0) { var np = n.slice(n.indexOf('/') + 1); return { url: 'cart/change.js', body: { id: b.key, quantity: b.qty + short - g.qty, selling_plan: np ? +np : null } }; }
        return { url: 'cart/change.js', body: { id: b.key, quantity: Math.max(0, b.qty - (g.qty - short)) } };
      }
    }
    for (i = 0; i < keys.length; i++) {
      g = G[keys[i]]; t = T[keys[i]] || 0; if (g.qty <= t) continue;
      if (!t) { var up = {}; g.items.forEach(function (it) { up[it.key] = 0; }); return { url: 'cart/update.js', body: { updates: up } }; }
      b = biggest(g); return { url: 'cart/change.js', body: { id: b.key, quantity: Math.max(0, b.qty - (g.qty - t)) } };
    }
    for (j = 0; j < tk.length; j++) {
      n = tk[j]; ng = G[n]; var have = ng ? ng.qty : 0; if (have >= T[n]) continue;
      if (ng) { b = biggest(ng); return { url: 'cart/change.js', body: { id: b.key, quantity: b.qty + T[n] - have } }; }
      var it0 = { id: +n.slice(0, n.indexOf('/')), quantity: T[n] }, sp = n.slice(n.indexOf('/') + 1); if (sp) it0.selling_plan = +sp;
      return { url: 'cart/add.js', body: { items: [it0] }, add: true };
    }
    return null;
  }
  /* what Shopify's lines look like after a request, as far as the bag can tell (to know which request is the last) */
  function simulate(items, st) {
    var out = items.map(function (x) { return { key: x.key, v: x.v, p: x.p, qty: x.qty }; }), b = st.body;
    if (st.add) { b.items.forEach(function (a) { out.push({ key: '', v: String(a.id), p: a.selling_plan ? String(a.selling_plan) : '', qty: a.quantity }); }); return out; }
    if (b.updates) return out.filter(function (x) { return !(x.key in b.updates); });
    var it = out.filter(function (x) { return x.key === b.id; })[0]; if (!it) return out;
    var grp = out.filter(function (x) { return x.v === it.v && x.p === it.p; }), tot = b.quantity - it.qty;
    grp.forEach(function (x) { tot += x.qty; });
    var np = 'selling_plan' in b ? (b.selling_plan ? String(b.selling_plan) : '') : it.p;
    out = out.filter(function (x) { return grp.indexOf(x) < 0; });
    var ex = out.filter(function (x) { return x.v === it.v && x.p === np; })[0];
    if (ex) ex.qty += tot; else if (tot > 0) out.push({ key: it.key, v: it.v, p: np, qty: tot });
    return out;
  }
  function runSync() {
    var r = roots()[0]; if (!r) return Promise.resolve();
    var gen = sy.gen, steps = [], vs = {};
    sy.run = true; sy.broken = false; busy(true);
    productLines(r).forEach(function (l) { vs[vOf(l.getAttribute('data-key'))] = 1; });
    var T = wantTotals(r), items = srvItems(r), n = 0, again = false;
    var want = predictGifts(), gs = giftSrv(r), rms = [], adds = [];
    if (want) {
      var S = gzStates();
      ['pouch', 'bottle'].forEach(function (id) {
        if (!(id in want)) return;
        if (want[id] && !gs[id]) { var g = S && S.gifts.filter(function (x) { return x.id === id; })[0]; if (g && g.v) adds.push({ id: +g.v, quantity: 1, properties: { _gift: id } }); }
        else if (!want[id] && gs[id]) rms.push(id);
      });
    }
    if (rms.length) steps.push(function (last, cj) {
      var up = {};
      rms.forEach(function (id) {
        var k = gs[id];
        if (cj && cj.items) { var it = cj.items.filter(function (x) { return x.properties && x.properties._gift === id; })[0]; k = it ? it.key : ''; }
        if (k) up[k] = 0;
      });
      if (!Object.keys(up).length) return last ? sectionsJson() : Promise.resolve(cj);
      return post('cart/update.js', last ? withSections({ updates: up }) : { updates: up }).then(function (j) { rms.forEach(function (id) { gs[id] = ''; }); if (j.items) sitems = itemsFrom(j, vs); return j; });
    });
    if (adds.length) steps.push(function (last) {
      return post('cart/add.js', last ? withSections({ items: adds }) : { items: adds }).then(function (j) {
        (j.items || []).forEach(function (it) { var id = it.properties && it.properties._gift; if (id) gs[id] = it.key; });
        return j;
      });
    });
    /* product lines first, one request after another, each worked out from Shopify's last answer; then the gifts */
    function prod(cj) {
      if (cj && cj.items) items = sitems = itemsFrom(cj, vs);
      var st = nextStep(items, T);
      if (!st) return Promise.resolve(cj);
      if (++n > 6) { sy.broken = true; return Promise.resolve(cj); }
      var last = !steps.length && !nextStep(simulate(items, st), T);
      return post(st.url, last ? withSections(st.body) : st.body).then(function (j) {
        if (!st.add) return prod(j);
        /* an add answers with the new line only: read the whole cart to carry on */
        return cartJson().then(function (c2) { if (j.sections) c2.sections = j.sections; return prod(c2); });
      }, function (e) {
        /* a line part Shopify no longer knows (a gift going in can split a line again): read the cart and work it out again, once */
        if (again) throw e;
        again = true;
        return cartJson().then(prod);
      });
    }
    var p = prod(null);
    steps.forEach(function (fn, i) { p = p.then(function (cj) { return fn(i === steps.length - 1, cj); }); });
    return p.then(function (j) {
      sy.run = false;
      /* the shopper changed something while Shopify was answering: the next pass redraws, unless Shopify merged lines we can't follow */
      if ((gen !== sy.gen || sy.t) && !sy.broken) return;
      if (sy.broken && sy.t) { clearTimeout(sy.t); sy.t = null; }
      if (j && j.sections) render(j.sections); else return refresh();
    }, function (e) {
      sy.run = false; clearTimeout(sy.t); sy.t = null;
      return refresh().then(function () { alertMsg(e.message); });
    }).then(function () { busy(false); });
  }
  /* what's being added, for the line that shows in the bag before Shopify answers: name and drawing from the card or page it came from */
  function prodInfo(src) {
    var c = src && src.closest ? src.closest('[data-sbp-panel], .sp-card, .sp-up, article, [data-sp-prod], .sp-section, section') : null;
    if (!c) return {};
    var m = c.querySelector('.sp-render svg, .sp-pack svg, .sp-sbp__art svg, .sp-up__media img, .sp-up__media svg, img');
    var t = null; ['.sp-sbp__name', '.sp-card__title', '.sp-up__title', 'h1', 'h2', 'h3'].some(function (q) { return (t = c.querySelector(q)); });
    var title = t ? t.childNodes[0] && t.childNodes[0].nodeType === 3 ? t.childNodes[0].textContent : t.textContent : '';
    return { media: m ? m.outerHTML : '', title: String(title || '').replace(/\s+/g, ' ').trim().replace(/ Strips$/, '') };
  }
  function withPrice(info, btn) { var m = btn && btn.querySelector && btn.querySelector('.sp-btn__meta'); if (m && /\d/.test(m.textContent)) info.price = m.textContent.trim(); return info; }
  function addPh(info) {
    roots().forEach(function (r) {
      var ul = r.querySelector('.sp-cart__lines'); if (!ul) return;
      var li = d.createElement('li');
      li.className = 'sp-line is-new is-ph is-ph-add';
      li.innerHTML = '<span class="sp-line__media">' + (info.media || '') + '</span><div class="sp-line__body"><div class="sp-line__top"><div class="sp-line__name"><span class="sp-line__title">' + esc(info.title || 'Your pick') + '</span><p class="sp-line__meta">Adding to your bag…</p></div>' + (info.price ? '<div class="sp-line__price"><strong>' + esc(info.price) + '</strong></div>' : '') + '</div></div>';
      ul.insertBefore(li, ul.firstChild);
    });
  }
  function dropPh() { [].forEach.call(d.querySelectorAll('.sp-line.is-ph-add'), function (x) { x.remove(); }); }
  /* another part of the site is adding to the bag (the stack builder, the quiz, product pairings): open the bag at once */
  function adding() {
    if (!bag() || onPage()) return;
    openBag(); addPh({}); stale();
    if (!sy.ext) { sy.ext = true; busy(true); }
    clearTimeout(sy.extT);
    /* most callers redraw the bag themselves once Shopify answers; if one doesn't, the bag fetches itself */
    sy.extT = setTimeout(function () {
      if (!sy.ext) return;
      refresh();
      sy.extT = setTimeout(function () { if (sy.ext) { sy.ext = false; busy(false); dropPh(); } }, 6000);
    }, 3000);
  }
  function removeLine(line) {
    if (!line) return;
    fold(line);
    flush();
    lock(function () {
      busy(true);
      return post('cart/change.js', withSections({ id: line.getAttribute('data-key'), quantity: 0 }))
        .then(function (j) { render(j.sections); }, function (e) { return refresh().then(function () { alertMsg(e.message); }); })
        .then(function () { busy(false); });
    });
  }
  function addVariant(id, btn) {
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
    if (btn && btn.closest('.sp-up')) { addPh(withPrice(prodInfo(btn), btn)); stale(); }
    busy(true);
    flush();
    return lock(function () {
      return post('cart/add.js', withSections({ items: [{ id: +id, quantity: 1 }] }))
        .then(function (j) { render(j.sections, { newKey: j.items && j.items[0] && j.items[0].key }); })
        .catch(function (e) { dropPh(); alertMsg(e.message); return refresh(); });
    }).then(function () { busy(false); if (btn && d.contains(btn)) { btn.classList.remove('is-loading'); btn.disabled = false; } });
  }
  function alertMsg(msg) { announce(msg); var r = roots()[0]; var box = r && r.querySelector('.sp-cart__main'); if (box) { var p = d.createElement('p'); p.className = 'sp-form-err'; p.setAttribute('role', 'alert'); p.textContent = msg; box.insertBefore(p, box.firstChild); setTimeout(function () { p.remove(); }, 5000); } }
  /* Add to bag: the bag opens at once with the new line on its way, and fills in when Shopify answers */
  function addForm(form, btn) {
    var fd = new FormData(form);
    fd.append('sections', ids()); fd.append('sections_url', location.pathname);
    var old = form.querySelector('.sp-form-err'); if (old) old.remove();
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
    if (!onPage()) { opener = btn || null; openBag(); }
    addPh(withPrice(prodInfo(form), btn)); stale();
    busy(true);
    flush();
    return lock(function () {
      return fetch(new Request(ROOT + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'X-Sp-Cart': '1' }, body: fd }))
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to your bag.'); return j; }); })
        .then(function (j) { render(j.sections, { newKey: j.key || (j.items && j.items[0] && j.items[0].key) }); })
        .catch(function (e) {
          dropPh();
          var p = d.createElement('p'); p.className = 'sp-form-err'; p.setAttribute('role', 'alert'); p.textContent = e.message;
          var at = (btn && btn.form === form && btn.parentNode) || form; at.appendChild(p);
          if (!onPage()) alertMsg(e.message);
          return refresh();
        });
    }).then(function () { busy(false); if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); } });
  }
  function codesOf(el) { var c = el.closest('[data-sp-codes]'); return c ? c.getAttribute('data-sp-codes').split(',') : []; }
  function codeErr(msg) {
    roots().forEach(function (r) {
      var e = r.querySelector('[data-sp-code-err]'); if (!e) return;
      e.textContent = msg; e.hidden = false;
      var det = e.closest('details'); if (det) det.open = true;
    });
  }
  function setCodes(list, fresh) {
    busy(true);
    flush();
    return lock(function () {
      return post('cart/update.js', withSections({ discount: uniq(list).join(',') }))
        .then(function (j) {
          var bad = fresh && (j.discount_codes || []).filter(function (dc) { return dc.code.toUpperCase() === fresh.toUpperCase() && !dc.applicable; })[0];
          if (!bad) { render(j.sections); return; }
          var keep = (j.discount_codes || []).filter(function (dc) { return dc.applicable; }).map(function (dc) { return dc.code; });
          return post('cart/update.js', withSections({ discount: keep.join(',') })).then(function (j2) {
            render(j2.sections);
            codeErr('“' + fresh + '” isn’t valid for this bag.');
          });
        })
        .catch(function (e) { alertMsg(e.message); });
    }).then(function () { busy(false); });
  }

  /* ---------- free Protocols ---------- */
  /* The bag works out how many Protocols are free (data-sp-pr-state). Extra ones (added, then a strip removed) are taken
     out again, newest first, and each Protocol stays at quantity 1. Checkout waits for that to finish. */
  var prT = null, prBusy = false, prTried = '';
  function prState() {
    var r = roots()[0], st = r && r.querySelector('[data-sp-pr-state]');
    if (!st) return null;
    var raw = st.getAttribute('data-lines') || '';
    return {
      allow: +st.getAttribute('data-allow') || 0,
      lines: raw.split(',').filter(Boolean).map(function (x) { var i = x.lastIndexOf(':'); return { key: x.slice(0, i), qty: +x.slice(i + 1) || 0 }; }),
      sig: st.getAttribute('data-allow') + '|' + raw
    };
  }
  function prFixes(st) {
    if (!st || !st.lines.length) return null;
    var up = {}, n = 0, extra = Math.max(0, st.lines.length - st.allow);
    st.lines.forEach(function (l, i) {
      if (i < extra) { up[l.key] = 0; n++; }
      else if (l.qty > 1) { up[l.key] = 1; n++; }
    });
    return n ? up : null;
  }
  function prEnforce() {
    if (prBusy) return Promise.resolve();
    var st = prState(), up = prFixes(st);
    if (!up || st.sig === prTried) return Promise.resolve();
    prTried = st.sig; prBusy = true; busy(true);
    return post('cart/update.js', withSections({ updates: up }))
      .then(function (j) { prBusy = false; render(j.sections); })
      .catch(function () { prBusy = false; })
      .then(function () { busy(false); });
  }
  function prMsg(box, text) {
    var m = box && box.querySelector('[data-sp-pr-msg]'); if (!m) return;
    m.textContent = text; m.hidden = false; announce(text);
    clearTimeout(m.__t); m.__t = setTimeout(function () { m.hidden = true; }, 4500);
  }
  function prPick(btn) {
    var box = btn.closest('[data-sp-pr]'); if (!box) return;
    var allow = +box.getAttribute('data-allow') || 0, sel = +box.getAttribute('data-sel') || 0, key = btn.getAttribute('data-key');
    if (btn.getAttribute('aria-disabled') === 'true') { prMsg(box, 'Add one more strip, or choose a 60 or 90-day plan, to unlock your free Protocols.'); return; }
    if (!key && sel >= allow) {
      var c = box.querySelector('.sp-pr__count'); if (c) { c.classList.remove('is-flash'); c.getBoundingClientRect(); c.classList.add('is-flash'); }
      prMsg(box, 'All ' + allow + ' free Protocol' + (allow > 1 ? 's are' : ' is') + ' chosen. Tap a chosen one to remove it, then pick another.');
      return;
    }
    btn.classList.add('is-loading');
    busy(true);
    flush();
    lock(function () {
      var req = key ? post('cart/change.js', withSections({ id: key, quantity: 0 })) : post('cart/add.js', withSections({ items: [{ id: +btn.getAttribute('data-variant'), quantity: 1 }] }));
      return req.then(function (j) { render(j.sections); }).catch(function (e) { btn.classList.remove('is-loading'); prMsg(box, e.message); });
    }).then(function () { busy(false); });
  }

  /* ---------- first-order welcome gifts: The Suprimal Pouch and The Suprimal Bottle ---------- */
  /* Each gift has a hidden state in the bag (data-sp-gift-state: earned or not, its line, its code). The bag adds an earned gift as a real
     line with the property _gift and applies the codes that make it $0; a gift and its code come out again when the bag stops qualifying.
     Taking a gift out is respected only while the bag stays the same: add a strip, change a plan or a quantity and every earned gift comes
     back on its own. The Bottle comes in the colour the shopper picked (black unless they chose white). If Shopify won't make a gift
     free, that gift is taken out with a note, and tried again once the bag changes. Checkout waits for this to finish.
     Shopify can make a gift free in two ways, and the bag works with both: its gift code, or an automatic discount with the same
     title as that code. Once a gift is free through the automatic discount, a gift code Shopify no longer accepts comes out of the bag. */
  var gzBusy = false, gzTried = '', gzRetry = 0, gzRuns = [];
  /* what the shopper chose, gifts left out: each product with its plan and quantity. Built from the variant and the plan, not the line
     key: Shopify splits and merges lines (and changes their keys) as the gift codes apply. */
  function bagSig() {
    var r = roots()[0]; if (!r) return '';
    var m = {};
    [].slice.call(r.querySelectorAll('.sp-line:not(.sp-line--gift)')).forEach(function (l) {
      var ps = l.querySelector('[data-sp-plan-select]');
      var k = String(l.getAttribute('data-key') || '').split(':')[0] + '/' + (ps ? ps.value : '');
      m[k] = (m[k] || 0) + (+l.getAttribute('data-qty') || 0);
    });
    return Object.keys(m).sort().map(function (k) { return k + ':' + m[k]; }).join(',') || 'empty';
  }
  function ss(k, v) {
    try { var S = window.sessionStorage; if (v === undefined) return S.getItem(k); if (v === null) S.removeItem(k); else S.setItem(k, v); } catch (e) {}
    return null;
  }
  function ucase(c) { return String(c || '').toUpperCase(); }
  function gzStates() {
    var r = roots()[0]; if (!r) return null;
    var els = [].slice.call(r.querySelectorAll('[data-sp-gift-state]'));
    if (!els.length) return null;
    var codes = (els[0].getAttribute('data-codes') || '').split(',').map(function (c) { return c.trim(); }).filter(Boolean);
    var sig = bagSig();
    var gifts = els.map(function (st) {
      var p = st.getAttribute('data-ss') || 'pz';
      var g = {
        id: st.getAttribute('data-gift'), p: p, code: st.getAttribute('data-code') || '',
        want: st.getAttribute('data-want') === '1', key: st.getAttribute('data-key') || '', cur: st.getAttribute('data-cur') || '',
        mine: st.getAttribute('data-mine') === '1', applied: st.getAttribute('data-applied') === '1', v: st.getAttribute('data-v') || '', colors: {},
        alt: st.getAttribute('data-alt') || '', altApplied: st.getAttribute('data-alt-applied') === '1'
      };
      (st.getAttribute('data-colors') || '').split(',').filter(Boolean).forEach(function (x) { var i = x.lastIndexOf(':'); g.colors[x.slice(0, i)] = x.slice(i + 1); });
      /* the saved pick: per gift prefix, or its own key (data-pk) when a pair holds two picks, like the Sweatshirt and its tin */
      var pick = ss('sp-' + (st.getAttribute('data-pk') || p) + '-color');
      if (pick && g.colors[pick]) g.v = g.colors[pick];
      else if (g.cur && g.mine) g.v = g.cur;
      /* a removed gift (or one Shopify refused) stays out only for this exact bag; any change to the bag forgets it */
      var dk = 'sp-' + p + '-declined', nk = 'sp-' + p + '-nodisc', dv = ss(dk), nv = ss(nk);
      if (dv && dv !== sig) { ss(dk, null); dv = null; }
      if (nv && nv !== sig) { ss(nk, null); nv = null; }
      g.off = dv === sig || nv === sig;
      return g;
    }).filter(function (g) { return g.code; });
    /* From 3 strips one code makes the Pouch and the Bottle free together, and Shopify only applies it with both in the bag:
       the set always brings the Pouch along, and if the shopper takes the Bottle out the Pouch goes back to its own code. */
    var pz = gifts.filter(function (g) { return g.id === 'pouch'; })[0], bt = gifts.filter(function (g) { return g.id === 'bottle'; })[0];
    if (pz && bt && pz.alt && ucase(pz.code) === ucase(bt.code)) {
      if (!bt.want || bt.off) { pz.code = pz.alt; pz.applied = pz.altApplied; }
      else if (pz.want) pz.off = false;
    }
    gifts.forEach(function (g) { g.hasCode = codes.some(function (c) { return ucase(c) === ucase(g.code); }); });
    var gc = [];
    gifts.forEach(function (g) { [g.code, g.alt].forEach(function (c) { if (c && gc.indexOf(ucase(c)) < 0) gc.push(ucase(c)); }); });
    return {
      codes: codes, gifts: gifts, gc: gc,
      sig: codes.join(',') + '|' + gifts.map(function (g) { return [g.id, g.code, g.want, g.key, g.cur, g.v, g.mine, g.applied, g.off, ss('sp-' + g.p + '-code')].join(':'); }).join(';')
    };
  }
  function gzPlan(S) {
    if (!S) return null;
    var plan = { remove: [], add: [], keep: [], dirty: false };
    var kc = S.gifts.filter(function (g) { return g.want && !g.off; }).map(function (g) { return ucase(g.code); });
    S.gifts.forEach(function (g) {
      if (g.want && !g.off) {
        plan.keep.push(g);
        if (!g.key) { if (g.v) { plan.add.push({ id: +g.v, quantity: 1, properties: { _gift: g.id } }); plan.dirty = true; } }
        else if (g.mine && g.v && g.cur && String(g.cur) !== String(g.v)) { plan.remove.push(g.key); plan.add.push({ id: +g.v, quantity: 1, properties: { _gift: g.id } }); plan.dirty = true; }
        else if (!g.applied) plan.dirty = true;
      } else {
        if (g.key && g.mine) { plan.remove.push(g.key); plan.dirty = true; }
        /* a gift code can sit in the cart unapplied, where Liquid can't see it: the flag says we put it there */
        if (kc.indexOf(ucase(g.code)) < 0 && (g.hasCode || ss('sp-' + g.p + '-code') === '1')) plan.dirty = true;
      }
    });
    return plan.dirty ? plan : null;
  }
  function pzNote(text) {
    roots().forEach(function (r) { var n = r.querySelector('[data-pz-note]'); if (n) { n.textContent = text; n.hidden = !text; } });
    if (text) announce(text);
  }
  function cartJson() { return fetch(ROOT + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  /* is a gift's discount on the bag? Its code, applied, or any line carrying a discount with that title (the code itself, or the
     automatic discount named after it). Shopify can put the $0 on a paid tin of the same price instead of the gift tin, so look at every line. */
  function gzOn(dj, code) {
    var u = ucase(code); if (!u) return false;
    if ((dj.discount_codes || []).some(function (x) { return ucase(x.code) === u && x.applicable; })) return true;
    return (dj.items || []).some(function (it) {
      return (it.line_level_discount_allocations || []).some(function (a) { return a.discount_application && ucase(a.discount_application.title) === u && +a.amount > 0; });
    });
  }
  function gzCodeOk(dj, code) { var u = ucase(code); return (dj.discount_codes || []).some(function (x) { return ucase(x.code) === u && x.applicable; }); }
  /* gift codes sitting in the bag that Shopify doesn't accept: switched off now that the gift's discount is automatic, or refused */
  function gzStale(dj, S) { return (dj.discount_codes || []).filter(function (x) { return !x.applicable && S.gc.indexOf(ucase(x.code)) > -1; }).map(function (x) { return ucase(x.code); }); }
  /* Which welcome gifts the bag earns as the shopper wants it, worked out in the browser with the bag's own numbers and rules
     (sp-pouch-units, sp-gift-tier): units and $ of strips and packs, before discounts. Null when the bag can't tell (returning
     customers, a plan without price data): the gift engine then settles it after the redraw. */
  function predictGifts() {
    var r = roots()[0]; if (!r) return null;
    var pz = r.querySelector('[data-sp-gift-state][data-gift="pouch"]'), bt = r.querySelector('[data-sp-gift-state][data-gift="bottle"]');
    if (!pz || pz.getAttribute('data-ok') !== '1' || pz.getAttribute('data-n1') === null) return null;
    var U = +pz.getAttribute('data-units') || 0, A = +pz.getAttribute('data-amt') || 0, known = true;
    productLines(r).forEach(function (l) {
      var x = lineRen(l), w = lineWant(l); if (!x.gm || (x.qty === w.qty && x.plan === w.plan)) return;
      var dl = x.gu / x.gm, up = x.ga;
      if (w.plan !== x.plan) {
        var o = optionFor(l, w.plan);
        if (!o || o.getAttribute('data-up') === null || o.getAttribute('data-up') === '') { known = false; return; }
        dl = +o.getAttribute('data-deliv') || 1; up = +o.getAttribute('data-up');
      }
      U += w.qty * x.gm * dl - x.qty * x.gu; A += w.qty * up - x.qty * x.ga;
    });
    if (!known) return null;
    var tier = U >= +pz.getAttribute('data-n2') && A >= +pz.getAttribute('data-m2') ? 2 : U >= +pz.getAttribute('data-n1') && A >= +pz.getAttribute('data-m1') ? 1 : 0;
    return { pouch: tier >= 1, bottle: tier >= 2 && !!bt && bt.getAttribute('data-ok') === '1' };
  }
  /* a gift on its way into the bag, drawn like the real line */
  function giftPh(r, id) {
    var st = r.querySelector('[data-sp-gift-state][data-gift="' + id + '"]'); if (!st || !st.getAttribute('data-title')) return null;
    var p = st.getAttribute('data-ss') || 'pz', img = st.getAttribute('data-img') || '', imgs = st.getAttribute('data-imgs') || '', pick = ss('sp-' + p + '-color');
    if (pick) imgs.split(',').forEach(function (x) { var i = x.indexOf(':'); if (i > 0 && x.slice(0, i) === pick) img = x.slice(i + 1); });
    var li = d.createElement('li');
    li.className = 'sp-line sp-line--gift sp-line--' + id + ' is-ph is-new';
    li.setAttribute('data-gift', id);
    li.innerHTML = '<span class="sp-line__media">' + (img ? '<img src="' + esc(img) + '" alt="">' : '') + '</span><div class="sp-line__body"><div class="sp-line__top"><div class="sp-line__name"><span class="sp-line__title">' + esc(st.getAttribute('data-title')) + '</span><p class="sp-line__meta"><span class="sp-badge sp-badge--gift">Free gift</span><span>First-order welcome gift</span></p></div><div class="sp-line__price">' + (st.getAttribute('data-cmp') ? '<s>' + esc(st.getAttribute('data-cmp')) + '</s>' : '') + '<strong>Free</strong></div></div><div class="sp-line__gift-foot"><span>Ships separately, no extra cost</span></div></div>';
    return li;
  }
  /* show the gifts the bag earns: a gift coming in appears at the top, a gift going out folds away, and a quick change back undoes it */
  function giftView(want) {
    roots().forEach(function (r) {
      var ul = r.querySelector('.sp-cart__lines'); if (!ul) return;
      ['pouch', 'bottle'].forEach(function (id) {
        if (!(id in want)) return;
        var real = r.querySelector('.sp-line--gift[data-gift="' + id + '"]:not(.is-ph)'), ph = r.querySelector('.sp-line--gift.is-ph[data-gift="' + id + '"]');
        if (want[id]) {
          if (real) { if (real.classList.contains('is-removing')) unfold(real); }
          else if (!ph) { var li = giftPh(r, id); if (li) ul.insertBefore(li, ul.firstChild); }
        } else {
          if (ph) ph.remove();
          if (real && !real.classList.contains('is-removing')) fold(real);
        }
      });
    });
  }
  /* the gift lines Shopify just added are free: $0, or carrying a discount with the gift's title */
  function gzAddedFree(j, plan) {
    var items = j.items || [];
    return plan.add.every(function (a) {
      var id = a.properties && a.properties._gift, g = plan.keep.filter(function (k) { return k.id === id; })[0], u = ucase(g ? g.code : '');
      var it = items.filter(function (x) { return x.properties && x.properties._gift === id; })[0];
      if (!it) return false;
      if (+it.final_line_price === 0) return true;
      return (it.line_level_discount_allocations || []).some(function (d) { return d.discount_application && ucase(d.discount_application.title) === u && +d.amount > 0; });
    });
  }
  /* The gifts' discounts are automatic, so the usual case is one request: add the gift with the bag's new look in the same answer
     (a colour or size swap first takes the old line out), or take a gift out the same way. Codes are only tried when Shopify didn't
     make a gift free (the fallback below, also used for carts that still carry an old gift code). */
  function gzEnforce() {
    if (gzBusy || pending()) return Promise.resolve();
    var S = gzStates(), plan = gzPlan(S);
    if (!plan || S.sig === gzTried) return Promise.resolve();
    /* safety net: at most 5 automatic fixes in 20 seconds without a tap from the shopper, so the bag can never loop */
    var now = Date.now(); gzRuns = gzRuns.filter(function (t) { return now - t < 20000; });
    if (gzRuns.length >= 5) return Promise.resolve();
    gzRuns.push(now);
    gzTried = S.sig; gzBusy = true; busy(true);
    var rm = null; if (plan.remove.length) { rm = {}; plan.remove.forEach(function (k) { rm[k] = 0; }); }
    var flagged = S.gifts.some(function (g) { return g.hasCode || ss('sp-' + g.p + '-code') === '1'; });
    var run;
    if (plan.add.length) {
      roots().forEach(function (r) { [].slice.call(r.querySelectorAll('[data-pz-add]')).forEach(function (b) { b.classList.add('is-loading'); }); });
      run = (rm ? post('cart/update.js', { updates: rm }) : Promise.resolve())
        .then(function () { return post('cart/add.js', withSections({ items: plan.add })); })
        .then(function (j) {
          if (!flagged && gzAddedFree(j, plan)) { S.gifts.forEach(function (g) { ss('sp-' + g.p + '-nodisc', null); }); render(j.sections); return; }
          return gzCodes(S, plan);
        });
    } else if (rm && !flagged) {
      stale();
      run = post('cart/update.js', withSections({ updates: rm })).then(function (j) { render(j.sections); });
    } else {
      run = (rm ? post('cart/update.js', { updates: rm }) : Promise.resolve()).then(function () { return gzCodes(S, plan); });
    }
    return run
      .then(function () { gzRetry = 0; })
      .catch(function () {
        /* the bag didn't answer: try again once, a moment later, then let the next change of the bag try */
        gzTried = '';
        if (gzRetry < 1) { gzRetry++; setTimeout(function () { refresh(); }, 1500); }
      })
      .then(function () { gzBusy = false; busy(false); });
  }
  /* fallback: apply the gift codes, look again, and take out any gift Shopify still won't make free (with a note) */
  function gzCodes(S, plan) {
    var want = plan.keep.map(function (g) { return g.code; });
    return cartJson()
      .then(function (cj) {
        var rest = (cj.discount_codes || []).map(function (x) { return x.code; }).filter(function (c) { return S.gc.indexOf(ucase(c)) < 0; });
        return post('cart/update.js', withSections({ discount: uniq(rest.concat(want)).join(',') }));
      })
      .then(function (j) {
        function notFree(dj) { return plan.keep.filter(function (g) { return !gzOn(dj, g.code); }); }
        if (!notFree(j).length) return { j: j, bad: [] };
        /* right after a change Shopify can call a gift code "not applicable" for a moment: look again before giving up on it */
        return new Promise(function (res) { setTimeout(res, 900); }).then(cartJson).then(function (cj2) { return { cj: cj2, bad: notFree(cj2) }; });
      })
      .then(function (o) {
        var bad = o.bad, j = o.j || o.cj;
        S.gifts.forEach(function (g) { ss('sp-' + g.p + '-code', plan.keep.indexOf(g) > -1 && bad.indexOf(g) < 0 && gzCodeOk(j, g.code) ? '1' : null); });
        var stale = gzStale(j, S);
        if (!bad.length) {
          if (stale.length) {
            var keep0 = (j.discount_codes || []).filter(function (x) { return stale.indexOf(ucase(x.code)) < 0; }).map(function (x) { return x.code; });
            return post('cart/update.js', withSections({ discount: keep0.join(',') })).then(function (j3) { render(j3.sections); });
          }
          if (o.j) render(o.j.sections); else return refresh(); return;
        }
        /* Shopify won't make it free here (already claimed, or a code it can't combine with): take that gift out again */
        var bsig = bagSig();
        var badIds = bad.map(function (g) { ss('sp-' + g.p + '-nodisc', bsig); return g.id; });
        var badCodes = bad.map(function (g) { return ucase(g.code); });
        var rm2 = {};
        (j.items || []).forEach(function (it) { if (it.properties && badIds.indexOf(it.properties._gift) > -1) rm2[it.key] = 0; });
        var keep = (j.discount_codes || []).filter(function (x) { return badCodes.indexOf(ucase(x.code)) < 0 && stale.indexOf(ucase(x.code)) < 0; }).map(function (x) { return x.code; });
        return post('cart/update.js', withSections({ updates: rm2, discount: keep.join(',') })).then(function (j2) {
          render(j2.sections);
          pzNote(badIds.indexOf('hood') > -1 || badIds.indexOf('htin') > -1 ? 'The Hoodie + tin are a thank-you for returning customers, once each. Sign in with the account you first ordered with to claim them.' : badIds.indexOf('sweat') > -1 || badIds.indexOf('stin') > -1 ? 'The Sweatshirt + tin are a thank-you for returning customers, once each. Sign in with the account you first ordered with to claim them.' : badIds.indexOf('bag') > -1 || badIds.indexOf('tin') > -1 ? 'The Bag + tin are a thank-you for returning customers, once each. Sign in with the account you first ordered with to claim them.' : badIds.indexOf('tee') > -1 || badIds.indexOf('cap') > -1 ? 'The Cap + T-shirt are a thank-you for returning customers, once each. Sign in with the account you first ordered with to claim them.' : badIds.indexOf('pouch') > -1 ? 'The welcome gifts are for a first order, one per customer, so they aren’t available on this order.' : 'The free Bottle is a first-order gift, one per customer, so it isn’t available on this order.');
        });
      });
  }
  /* which gift a bag element belongs to: pz (the Pouch), bt (the Bottle), ct (the Cap + T-shirt pair), bg (the Bag + tin pair), sw (the Sweatshirt + tin pair) or hd (the Hoodie + tin pair) */
  function gzPrefix(el) { return el.getAttribute('data-ss') || (el.getAttribute('data-gift') === 'bottle' ? 'bt' : 'pz'); }
  /* product pages: "Add my free gift" (and the Bottle colour or the T-shirt). Forgets an earlier "remove", then lets the bag add or swap it. */
  function gzClaim(id, color) {
    var ps = id === 'bottle' ? ['bt', 'pz'] : (id === 'tee' || id === 'cap') ? ['ct'] : (id === 'bag' || id === 'tin') ? ['bg'] : (id === 'sweat' || id === 'stin') ? ['sw'] : (id === 'hood' || id === 'htin') ? ['hd'] : ['pz'];
    ps.forEach(function (p) { ss('sp-' + p + '-declined', null); ss('sp-' + p + '-nodisc', null); });
    if (color) ss('sp-' + ps[0] + '-color', color);
    gzTried = '';
    return refresh(true);
  }

  /* ---------- events ---------- */
  d.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    gzRuns = [];
    if (t.closest('[data-sp-cart-close]')) { e.preventDefault(); closeBag(); return; }
    var step = t.closest('[data-sp-qty-step]');
    if (step) {
      var line = step.closest('.sp-line'); if (!line || line.classList.contains('is-ph')) return;
      setWant(line, { qty: lineWant(line).qty + (+step.getAttribute('data-sp-qty-step')) }, 350); return;
    }
    var rm = t.closest('[data-sp-remove]');
    if (rm) {
      var rl = rm.closest('.sp-line'); if (!rl || rl.classList.contains('is-ph')) return;
      var gl = rm.closest('.sp-line--gift');
      if (gl) { ss('sp-' + gzPrefix(gl) + '-declined', bagSig()); removeLine(rl); return; }
      setWant(rl, { qty: 0 }, 120); return;
    }
    var pza = t.closest('[data-pz-add]'); if (pza) { e.preventDefault(); var gp = gzPrefix(pza); ss('sp-' + gp + '-declined', null); ss('sp-' + gp + '-nodisc', null); gzTried = ''; pza.classList.add('is-loading'); flush(); lock(gzEnforce); return; }
    var sw = t.closest('[data-bt-color]');
    if (sw) {
      e.preventDefault(); if (sw.getAttribute('aria-pressed') === 'true') return;
      ss('sp-bt-color', sw.getAttribute('data-bt-color')); gzTried = '';
      var swl = sw.closest('.sp-line');
      if (swl) {
        [].slice.call(swl.querySelectorAll('[data-bt-color]')).forEach(function (b) { b.setAttribute('aria-pressed', b === sw ? 'true' : 'false'); });
        var swi = swl.querySelector('.sp-line__media img'), src = sw.getAttribute('data-img');
        if (swi && src) { swi.removeAttribute('srcset'); swi.src = src; }
      }
      /* a change still on its way goes first; the colour follows in the redraw after it */
      if (!pending()) lock(gzEnforce);
      return;
    }
    var pk = t.closest('[data-sp-pr-pick]'); if (pk) { e.preventDefault(); prPick(pk); return; }
    var pj = t.closest('[data-sp-pr-jump]');
    if (pj) {
      e.preventDefault();
      var pbox = pj.closest('[data-sp-cart]') && pj.closest('[data-sp-cart]').querySelector('[data-sp-pr]');
      if (pbox) { pbox.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' }); pbox.classList.remove('is-ping'); pbox.getBoundingClientRect(); pbox.classList.add('is-ping'); }
      return;
    }
    var ad = t.closest('[data-sp-add]'); if (ad) { e.preventDefault(); addVariant(ad.getAttribute('data-sp-add'), ad); return; }
    var cr = t.closest('[data-sp-code-remove]');
    if (cr) { var v = cr.getAttribute('data-sp-code-remove'); setCodes(codesOf(cr).filter(function (c) { return c.toUpperCase() !== v.toUpperCase(); })); return; }
    var a = t.closest('a[href]');
    if (a && bag() && !onPage() && !e.defaultPrevented && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey && (a.closest('.sp-header, .sp-sheet') || a.hasAttribute('data-sp-cart-open'))) {
      if (/\/cart\/?$/.test(a.pathname)) { e.preventDefault(); opener = a; openBag(); if (!pending()) refresh(); }
    }
  });
  d.addEventListener('change', function (e) {
    var t = e.target; if (!t.closest) return;
    gzRuns = [];
    /* the free T-shirt or Sweatshirt in the bag: colour + size pick the variant, then the bag swaps it */
    if (t.hasAttribute('data-ct-opt')) {
      var tl = t.closest('.sp-line'), cs = tl && tl.querySelector('[data-ct-opt="c"]'), zs = tl && tl.querySelector('[data-ct-opt="s"]');
      if (cs && zs) { ss('sp-' + (tl.getAttribute('data-ss') || 'ct') + '-color', cs.value + '-' + zs.value); gzTried = ''; if (!pending()) lock(gzEnforce); }
      return;
    }
    /* the free tin in the bag (6-month or 9-month thank-you): the bag swaps it, and the choice is saved on the order */
    if (t.hasAttribute('data-bg-tin')) {
      var bo = t.options[t.selectedIndex], bat = {};
      ss('sp-' + (t.getAttribute('data-pk') || 'bg') + '-color', t.value); gzTried = '';
      if (t.getAttribute('data-attr') && bo) bat[t.getAttribute('data-attr')] = bo.getAttribute('data-title') || bo.textContent;
      lock(function () { return Object.keys(bat).length ? post('cart/update.js', { attributes: bat }).catch(function () {}) : null; }).then(function () { if (!pending()) return lock(gzEnforce); });
      return;
    }
    /* thank-you picks saved on the order: the T-shirt (first orders), the free tin (on the way to the 6-month thank-you), or the Sweatshirt and its tin (9-month) */
    var ga = t.closest('[data-gift-attr]');
    if (ga) {
      var gc = ga.querySelector('[data-part="c"]'), gz = ga.querySelector('[data-part="s"]'), gt = ga.querySelector('[data-part="t"]'), at = {};
      if (gt) { at[ga.getAttribute('data-gift-attr')] = gt.value; var go = gt.options[gt.selectedIndex]; if (go && go.getAttribute('data-h')) ss('sp-' + (ga.getAttribute('data-pk') || 'bg') + '-color', go.getAttribute('data-h')); }
      else at[ga.getAttribute('data-gift-attr')] = (gc ? gc.value : '') + ' / ' + (gz ? gz.value : '');
      lock(function () { return post('cart/update.js', { attributes: at }).catch(function () {}); });
      return;
    }
    var line = t.closest('.sp-line');
    if (t.hasAttribute('data-sp-plan-select') && line) {
      setWant(line, { plan: t.value }, 150);
    } else if (t.hasAttribute('data-sp-qty-input') && line) {
      setWant(line, { qty: Math.max(0, parseInt(t.value, 10) || 0) }, 300);
    } else if (t.hasAttribute('data-sp-protect')) {
      if (t.checked) addVariant(t.getAttribute('data-variant'));
      else if (t.getAttribute('data-key')) {
        var pkey = t.getAttribute('data-key');
        busy(true); flush();
        lock(function () { return post('cart/change.js', withSections({ id: pkey, quantity: 0 })).then(function (j) { render(j.sections); }, function (er) { return refresh().then(function () { alertMsg(er.message); }); }); }).then(function () { busy(false); });
      }
    }
  });
  d.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.hasAttribute && e.target.hasAttribute('data-sp-qty-input')) { e.preventDefault(); e.target.blur(); return; }
    var b = bag(); if (!b || b.hidden) return;
    if (e.key === 'Escape') { closeBag(); return; }
    if (e.key !== 'Tab') return;
    var f = [].slice.call(b.querySelectorAll('a[href],button:not([disabled]),input,select,summary')).filter(function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    if (e.shiftKey && (d.activeElement === f[0] || !b.contains(d.activeElement))) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && d.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  });
  d.addEventListener('submit', function (e) {
    var f = e.target;
    gzRuns = [];
    if (f.classList && f.classList.contains('sp-cart__form')) {
      /* checkout waits for any change still on its way, the Protocols and the gifts */
      if (pending() || prFixes(prState()) || gzPlan(gzStates())) {
        e.preventDefault();
        [].forEach.call(d.querySelectorAll('[data-sp-checkout]'), function (b) { b.classList.add('is-loading'); });
        flush().then(function () { return new Promise(function (res) { setTimeout(res, 0); }); }).then(function () { return mx; })
          .then(function () { prTried = ''; gzTried = ''; return lock(prEnforce); })
          .then(function () { return lock(gzEnforce); })
          .then(function () { location.href = ROOT + 'checkout'; });
      }
      return;
    }
    if (f.hasAttribute('data-sp-code-form')) {
      e.preventDefault();
      var v = (f.querySelector('input[name="code"]').value || '').trim();
      if (v) setCodes(codesOf(f).concat([v]), v);
      return;
    }
    var action = f.getAttribute('action') || '';
    if (/\/cart\/add/.test(action) && !f.hasAttribute('data-sp-native') && ids() && window.fetch && window.FormData) {
      e.preventDefault();
      addForm(f, e.submitter || f.querySelector('[type="submit"]'));
    }
  });
  d.addEventListener('shopify:section:select', function (e) { if (e.target.querySelector && e.target.querySelector('[data-sp-bag]')) openBag(); });
  d.addEventListener('shopify:section:deselect', function (e) { if (e.target.querySelector && e.target.querySelector('[data-sp-bag]')) closeBag(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  /* the stack builder, the quiz and product pairings add with their own requests: the bag opens the moment they send one */
  (function () {
    var of = window.fetch; if (!of) return;
    window.fetch = function (input, init) {
      try {
        var u = typeof input === 'string' ? input : (input && input.url) || '', m = String((init && init.method) || (input && input.method) || 'GET');
        var h = init && init.headers, mine = (h && (h['X-Sp-Cart'] || (h.get && h.get('X-Sp-Cart')))) || (input && input.headers && input.headers.get && input.headers.get('X-Sp-Cart'));
        if (!mine && /post/i.test(m) && /\/cart\/add(\.js)?(\?|$)/.test(u)) adding();
      } catch (err) {}
      return of.apply(this, arguments);
    };
  })();

  roots().forEach(function (el) { hydrate(el, null); });
  window.SuprimalCart = { open: openBag, close: closeBag, refresh: refresh, claim: gzClaim, adding: adding, flush: flush };
})();
